// Intercept-JS targeting reads properties on `QSI.config` at intercept-eval
// time, so we mirror known keys onto `QSI.config.netilion.*`. The Qualtrics
// CDN loader is assumed to merge onto an existing `window.QSI` rather than
// hard-reassign — verify empirically after deploy by checking
// `window.QSI?.config?.netilion` in DevTools.
declare global {
  interface Window {
    QSI?: {
      config?: Record<string, unknown>;
    };
  }
}

// Maps caller-facing keys to their leaf names under `QSI.config.netilion.*`.
// Unknown keys are silently ignored.
const CONFIG_LEAF_BY_KEY: Record<string, string> = {
  netilion_user_id: "user_id",
  service_app: "app",
  user_segment: "segment",
  locale: "locale",
};

function isPlainObject(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

function writeToConfig(key: string, value: string): void {
  if (globalThis.window === undefined) return;
  const leaf = CONFIG_LEAF_BY_KEY[key];
  if (leaf === undefined) return;
  const existingQsi = globalThis.window.QSI;
  const qsi = existingQsi ?? {};
  const config = isPlainObject(qsi.config) ? { ...qsi.config } : {};
  const existingNamespace = isPlainObject(config.netilion)
    ? config.netilion
    : {};
  config.netilion = { ...existingNamespace, [leaf]: value };
  qsi.config = config;
  if (existingQsi === undefined) {
    globalThis.window.QSI = qsi;
  }
}

export function setConfigValue(key: string, value: string): void {
  writeToConfig(key, value);
}

export function reset(): void {
  if (globalThis.window === undefined) return;
  const qsi = globalThis.window.QSI;
  if (!isPlainObject(qsi?.config)) return;
  const nextConfig: Record<string, unknown> = {};
  Object.keys(qsi.config).forEach((k) => {
    if (k !== "netilion") nextConfig[k] = qsi.config![k];
  });
  qsi.config = nextConfig;
}
